<template>
  <div v-if="isAdmin" class="bottom">
    <el-button
      type="success"
      icon="el-icon-s-promotion"
      round
      @click="publish">
      Publicar
    </el-button>
    <p class="cache-date">
      Ultima actualización: {{ cacheDate | timeAgo }}
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import http from '@/utils/http';
import store from '../observables/carrier';

export default {
  name: 'PublishRules',
  props: ['ruleType'],
  data() {
    return {
      cacheDate: '',
    };
  },
  computed: {
    ...mapGetters(['isAdmin']),
    carrier() {
      return store.carrier;
    },
  },
  watch: {
    carrier() {
      this.getCacheDate();
    },
  },
  created() {
    this.getCacheDate();
  },
  methods: {
    async getCacheDate() {
      const response = await http
        .get(`/credential/refresh?carrier=${this.carrier}&type=${this.ruleType}`);
      this.cacheDate = response.data.created_at;
    },
    async publish() {
      try {
        const body = {
          carrier: this.carrier,
          type: this.ruleType,
        };
        const { data } = await http.post('/credential/refresh', body);
        this.cacheDate = data.created_at;
        this.showSuccessMessage();
      } catch (error) {
        this.showErrorMessage(error);
      }
    },
    showSuccessMessage() {
      const options = {
        message: `Se actualizaron los cambios de proveedores para ${this.carrier}.`,
        type: 'info',
        duration: 4000,
      };
      this.$message(options);
    },
    showErrorMessage(message) {
      const options = {
        message,
        type: 'error',
      };
      this.$message(options);
    },
  },
};
</script>
<style scoped>
.bottom {
  text-align: center;
  margin-top: 23px;
  line-height: 12px;
}
</style>
